
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.793 39.388c-.26 0-.51-.1-.71-.289-.73-.727-4.11-5.127-5.839-8.383a7.42 7.42 0 01-.9-3.524c0-4.082 3.34-7.407 7.44-7.407 4.098 0 7.438 3.325 7.438 7.407 0 1.185-.29 2.37-.84 3.425-.01.02-.02.05-.04.07-.02.03-.04.07-.06.099-1.68 3.186-5.06 7.586-5.789 8.313-.19.19-.45.289-.7.289zm-4.78-9.607c1.34 2.508 3.59 5.575 4.78 7.068 1.19-1.493 3.46-4.59 4.77-7.068.01-.02.02-.03.02-.05.42-.787.64-1.643.64-2.549 0-2.987-2.44-5.416-5.44-5.416-3 0-5.44 2.43-5.44 5.416a5.3 5.3 0 00.64 2.549c.02.02.03.04.03.05z"}}),_c('path',{attrs:{"d":"M50.68 48.826c-.07 0-.13-.01-.2-.02l-13.728-2.718-13.728 2.718c-.13.03-.26.03-.39 0L8.716 46.048a.985.985 0 01-.8-.976v-33.74c0-.298.13-.577.37-.766.23-.19.54-.259.83-.21l13.728 2.719 13.728-2.718c.13-.03.26-.03.39 0l13.918 2.758c.47.09.8.497.8.975v33.74c0 .299-.13.578-.37.767-.18.16-.4.229-.63.229zm-40.774-4.57l12.918 2.559 13.728-2.718c.13-.03.26-.03.39 0l12.728 2.529v-31.71l-12.918-2.558-13.728 2.718c-.13.03-.26.03-.39 0L9.906 12.547v31.71z"}})])
          )
        }
      }
    